import { Dialog, Paper, useTheme } from '@mui/material'
import { appSelectors } from '@src/data/store/AppStore'
import { ReactNode, type JSX } from 'react'
import Layout from '../containers/App/AppHeader'
import { useAppSelector } from '../data/store'
import { userSelectors } from '../data/store/UserStore'

interface Props {
  children?: ReactNode
}

const FullScreenContainer = ({ children }: Props): JSX.Element => {
  const isIcebergGrDevs = useAppSelector(userSelectors.isIcebergGrDevs)
  const deprecated = useAppSelector(appSelectors.isDeprecated)
  const hasAlertBanner = isIcebergGrDevs || (import.meta.env.PROD && deprecated)
  const theme = useTheme()

  return (
    <Paper>
      <Dialog
        slotProps={{
          paper: {
            style: {
              backgroundColor: theme.palette.background.default,
              background: theme.palette.background.default,
            },
          },
        }}
        fullScreen
        open
      >
        <Layout hasAlertBanner={hasAlertBanner} />
        <div style={{ paddingLeft: '5rem', paddingRight: '5rem' }}>{children}</div>
      </Dialog>
    </Paper>
  )
}

export default FullScreenContainer
